import { render, staticRenderFns } from "./CsuDiagnosisPhase.vue?vue&type=template&id=f83105c0&scoped=true&"
import script from "./CsuDiagnosisPhase.vue?vue&type=script&lang=js&"
export * from "./CsuDiagnosisPhase.vue?vue&type=script&lang=js&"
import style0 from "./CsuDiagnosisPhase.vue?vue&type=style&index=0&id=f83105c0&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f83105c0",
  null
  
)

export default component.exports